import React, {Component} from "react"
import {countBy} from "lodash"
import Button, {IconButton} from "@irati/ui/src/Button"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, H4} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {FIRSTNAME, EMAIL} from "@irati/admin/helpers/userCSV"

import Column from "./Column/Column"
import {Columns, Error, TableContainer} from "./styled"

interface OptionalProps {
  headers?: string[]
  alignLeft?: boolean
  csv?: any[]
  isLoading?: boolean
  options?: {value: string; label: string}[] | null
  requiredHeaders?: string[]
  requiredMessage?: string
  buttonText?: string
}

interface Props extends OptionalProps, InjectIntl {
  updateHeader: (value: string, idx: number) => void
  submitUsers: () => void
  usersLength: number
  back: () => void
}

class AddPeopleHeaders extends Component<Props> {
  static defaultProps: OptionalProps = {
    headers: [],
    csv: [],
    isLoading: false,
    options: null,
    requiredHeaders: [FIRSTNAME, EMAIL],
    requiredMessage: "admin.components.addPeopleHeaders.headerFour.firstNameAndEmail",
    buttonText: "admin.components.addPeopleHeaders.button.invite"
  }

  hasRequired = () => {
    const {headers, requiredHeaders} = this.props

    return (
      countBy(headers.map((header) => !!requiredHeaders.find((requiredHeader) => requiredHeader === header))).true ===
      requiredHeaders.length
    )
  }

  renderTitle() {
    const {formatMessage, headers} = this.props
    const hasHeaders = headers!.every((value) => !!value)

    if (hasHeaders && this.hasRequired()) {
      return formatMessage({id: "admin.components.addPeopleHeaders.header.rightDocument"})
    }
    return formatMessage({id: "admin.components.addPeopleHeaders.header.couldntMatchHeaders"})
  }

  render() {
    const {requiredMessage, buttonText, headers, options, updateHeader, isLoading, submitUsers, usersLength, csv, alignLeft, back} =
      this.props

    const HeaderWrapper = alignLeft ? Flex : React.Fragment

    return (
      <Flex justifyContent={alignLeft ? "flex-start" : "center"} direction="column">
        <HeaderWrapper alignItems="center" margin="0 0 30px 0">
          {back && <IconButton onClick={back} icon="backArrow" />}
          <H2 margin={alignLeft ? "0 0 0 15px" : "0 auto 15px"}>
            <FormattedMessage id="admin.components.addPeopleHeaders.headerFour.mapColumns" />
          </H2>
        </HeaderWrapper>
        <H4 base margin={!alignLeft && "0 auto 15px"}>
          {this.renderTitle()}
        </H4>
        {!this.hasRequired() && (
          <Error base>
            <FormattedMessage id={requiredMessage} />
          </Error>
        )}
        <TableContainer alignLeft={alignLeft}>
          <Columns>
            {headers.map((header: string, i: number) => (
              <Column options={options} key={i} header={header} idx={i} changeHeader={updateHeader} isValid={header}>
                {csv.map((value: string, idx: number) => {
                  const column = Object.keys(value)[i]
                  return (
                    <div key={idx} className="header-value">
                      {value[column]}
                    </div>
                  )
                })}
              </Column>
            ))}
          </Columns>
          <Button primary large disabled={!this.hasRequired() || isLoading} onClick={submitUsers}>
            {isLoading ? (
              <FormattedMessage id="admin.components.addPeopleHeaders.button.uploading" />
            ) : (
              <FormattedMessage id={buttonText} values={{usersLength}} />
            )}
          </Button>
        </TableContainer>
      </Flex>
    )
  }
}

export default injectIntl(AddPeopleHeaders)
